// @flow

import * as React from "react"
import Config from "../../../config"
import {FilePond, File, doka} from "../../filepond"

type Props = {
  shopId: string,
  shopName: string,
  shopToken: string,
  babyImage: string,
}

type State = {
  files: any[],
  inputs: any[],
  loaded: boolean,
}

export default class ShopBabyImageUploader extends React.Component<
  Props,
  State
> {
  pond: FilePond
  handleInit: Function
  handleUpdateFiles: Function
  process: Function

  constructor(props: Props) {
    super(props)

    let files = []

    if (this.props.babyImage !== null && this.props.babyImage !== "") {
      files.push(this.props.shopId)
    }

    this.state = {loaded: this.props.babyImage !== "", files, inputs: []}

    this.handleInit = this.handleInit.bind(this)
    this.handleUpdateFiles = this.handleUpdateFiles.bind(this)
    this.process = this.process.bind(this)
  }

  handleUpdateFiles(fileItems: any[]) {
    this.setState({
      files: fileItems.map((fileItem) => fileItem.file),
    })
  }

  handleInit() {
    // console.log('FilePond instance has initialised', this.pond)
  }

  handleFileLoaded(request: XMLHttpRequest, load: Function, error: Function) {
    const {shopId, shopName, shopToken} = this.props

    if (request.status < 200 || request.status >= 300) {
      error("oh nos")
      return
    }

    load(request.responseText)

    const result = JSON.parse(request.responseText)
    if (result.data) {
      const media = result.data

      if (!shopId) {
        const {baseUrl, shopLocale} = Config
        window.location.href = `${baseUrl}/${shopLocale}/${shopName}/${shopToken}/baby-image/edit`
      } else {
        this.setState({
          inputs: [...this.state.inputs, media],
        })
      }
    }
  }

  process(
    fieldName: string,
    file: Object,
    metadata: Object,
    load: Function,
    error: Function,
    progress: Function /*,
    abort: Function*/
  ) {
    const {shopId, shopName, shopToken} = this.props
    const formData = new FormData()
    formData.append(fieldName, file, file.name)
    shopId && formData.append("shop_id", shopId)

    const {baseUrl, shopLocale} = Config
    const request = new XMLHttpRequest()
    request.open(
      "POST",
      `${baseUrl}/${shopLocale}/${shopName}/${shopToken}/baby-image`
    )
    request.setRequestHeader("X-CSRF-Token", window.menageConfig._csrf_token)

    request.onload = () => this.handleFileLoaded(request, load, error)
    request.upload.onprogress = (e) => {
      progress(e.lengthComputable, e.loaded, e.total)
    }

    request.send(formData)
  }

  render() {
    const {shopId} = this.props
    const {inputs, files} = this.state

    const server = {
      process: this.process,
      revert: null,
    }

    return [
      <FilePond
        key="filepond"
        ref={(ref) => (this.pond = ref)}
        allowMultiple={false}
        allowImageEdit={shopId !== null}
        imageEditEditor={doka}
        acceptedFileTypes={["image/png", "image/jpeg"]}
        dropOnPage={true}
        maxFiles={1}
        server={server}
        oninit={this.handleInit}
        onremovefile={(file) => {
          console.log("remove", file)
        }}
        onupdatefiles={this.handleUpdateFiles}
      >
        {files.map((file) => (
          <File key={`shop-image-${file}`} src={file} origin="local" />
        ))}
      </FilePond>,
      <div key="inputs" className="form-group">
        {inputs.map((image) => (
          <input
            key={`i-h-${image.id}`}
            type="hidden"
            name="new_image_id[]"
            value={image.id}
          />
        ))}
      </div>,
    ]
  }
}
